<template>
  <div>
    <div v-wechat-title="$tm('index2024.brand.title')" />
    <GcSkeleton :is-show="loading" />
    <GcGuide :down-show="guideShow" @showDwon="getGuideStatus" />
    <ShareInfo :share-info="shareData" />
    <!-- <template v-if="setTimeHide">
      <div v-if="dataInfo?.sort == 1 &&" class="prize_2022">
        <Lottie 
          :animation-data="prize2024.animationData" 
          :autoplay="prize2024.autoplay"
          :loop="prize2024.loop"
        />
      </div>
    </template> -->
    <Banner type="brand">
      <template #explainRule class="explain_rule">
        <Rule :is-round="false" :type="pathInfo.type" @ruleTrigger="onRuleTrigger"/>
      </template>
    </Banner>
    <div class="index_content brand_content">
      <!-- 入围提示 -->
      <Prize 
        v-if="dataInfo?.sort && dataInfo?.sort < 21"
        :type="pathInfo.type"
        :data-info="dataInfo" 
      ></Prize>

      <ul class="brand_list mt20">
        <li v-for="item in listData" :key="item.leader_id" class="list_item rds4" @click="goPath('userview', item)">
          <div :class="'ranking ranking'+item.sort"><span class="ft_bm">TOP</span> <i class="ft_bm">{{ addZero(item.sort) }}</i></div>
          <!-- <div class="hot_black ft_bm"><span> {{ item.heat }}</span></div> -->
          <div class=" top_img" :style="{'backgroundImage':'url('+ item.img1 +')'}">
            <div class="mask_banner" />
          </div>
          <div class="item_bottom">
            <div class="bottom_left">
              <img :src="item.img2" alt="" class="brand_img">
              <div class="left_text">
                <h3 class="font_bold text_over">{{ item.title }}</h3>
                <p class="text_overflow2">{{ item?.data?.slogan }}</p>
              </div>
            </div>
            <span v-if="item.followed" class="followBtn rds48 followBtnEnd" @click.stop="follow(item, 'followDelTo2024')">{{ $tm(`index2024.followingText`) }}</span>
            <span v-else class="followBtn rds48" @click.stop="follow(item, 'followAddTo2024')">{{ $tm(`index2024.followText`) }}</span>
          </div>
        </li>
      </ul>
    </div>
    <SideMenu :type="pathInfo.type" />
    <Footer />
  </div>
</template>

<script>
import { Toast } from 'vant'
import config from '@/config/config'
import { ajaxHttp } from '@/api/api'
import utils, { addZero } from '@/utils/utils'
import { superLink, checkloginCallback, platformType, is } from '@/utils/index'

import Banner from '../components/banner'
import Footer from '../components/footer'
import Rule from '../components/rule'
import SideMenu from '../components/sideMenu'
import Prize from '../components/prize'
import ShareInfo from '@/components/shareInfo'
import GcGuide from '@/components/gc-guide'
import GcSkeleton from '@/components/gc-skeleton'

// import gifing from '../gifData/index.js'

let timeout1 = null
export default {
  name: 'Brand',
  components: {
    Banner,
    Footer,
    SideMenu,
    ShareInfo,
    GcGuide,
    GcSkeleton,
    Rule,
    Prize
  },
  data() {
    return {
      loading: true, // 接口loading效果
      guideShow: false, // 微信点击的引导提示框
      pathInfo: {}, // 页面路径传参
      dataInfo: {}, // 用户相关信息
      listData: [], // 列表数据
      setTimeHide: true, // 礼花动画 1S 后隐藏 
      shareData: { // 分享数据
        share_title: '',
        share_des: '',
        share_link: '',
        share_img: ''
      },
      // prize2024: { // 主页 聚合页
      //   animationData: gifing.prize, 
      //   renderer: 'svg', 
      //   loop: false, 
      //   autoplay: true
      // }
    }
  },
  created() {
    const { query } = this.$route
    this.pathInfo = query

    this.getListData()

    this.shareData = {
      share_title: this.$tm(`index2024.${query.type}`).share_title,
      share_desc: this.$tm(`index2024.${query.type}`).share_des,
      share_link: location.href,
      share_img: 'https://static.mingchu.co/webapp/index2024/share/brand.png'
    }

    if (utils.getQueryVariable('token')) {
      this.shareData.share_title = '2024 不容错过的人气品牌。' 
      this.shareData.share_img = 'https://static.mingchu.co/webapp/index2024/minishare/brand.png' 
    }
  },
  mounted() {
    window.scroll(0, 0)
    window.mitt.on('guideShow', ($info) => { // 监听微信内点击弹起引导提示框
      this.guideShow = $info
    })
    
    const self = this
    timeout1 = setTimeout(() => {
      self.setTimeHide = false
    }, 4500)

    /* eslint-disable */
    sensors.track('MCINDEX2024_visit', {
      MCINDEX_title: 'brand',
      from: '2024指数_最受欢迎的品牌页面访问量',
      PlatformType: platformType()
    })
  },
  destroyed() {
    window.mitt.off('guideShow') // 销毁
    clearTimeout(timeout1)
  },
  methods: {
    addZero,
    // 判断用户是否登录展示 查看详情
    showTopDetail (data) {
      if (utils.isGteatChefbrowser()) {
        utils.isLogin().then((res_login) => {
          const resLogin = JSON.parse(res_login)
          if (resLogin.data.is_login === 1) {
            // 登陆成功
            this.dataInfo = data
          }
        })
        return
      }

      if (utils.is_mini() && utils.getQueryVariable('token')) {
        this.dataInfo = data

        return
      }

      this.dataInfo = {}
    },
    // 获取列表数据
    async getListData() {
      const self = this
      await ajaxHttp.$get(
        '/api/ranking2024/detail', 
        { ...self.pathInfo, leader_type: 'brand' }
      ).then(res => {
        if (res.code === 1) {
          // 判断用户是否登录
          this.showTopDetail(res.data.cuser_data)
          this.listData = res.data.leaders ?? []
        }
        this.$nextTick(() => {
          self.loading = false
        })
      })
    },
    // 关注
    follow(item, type) {
      checkloginCallback( // 检查app是否登录，然后执行回调函数
        async function() { // 统一的接口请求方法
          Toast.loading({ message: 'Loading...', forbidClick: true })
          const res = await ajaxHttp[type]({ follow_user_id: item.leader_id })
          if (res.code === 1) { 
            item.followed = !!Number(res.data.follow_status)
          }
          Toast.clear()
        }, this // 要传进去个this
      )
      /* eslint-disable */
      sensors.track('MCINDEX2024_follow', {
        MCINDEX_title: 'brand',
        from: '2024指数_最受欢迎的品牌页面关注',
        PlatformType: platformType()
      })
    },
    goPath($des, _item) {
      // JSON标准格式双引号，eslint默认单引号，冲突
      sensors.track('MCINDEX2024_card_click', {
        MCINDEX_title: 'brand',
        from: '2024指数_最受欢迎的品牌页面卡片点击',
        card_name: _item.title,
        PlatformType: platformType()
      })

      const data = `{
        "des": "${$des}", 
        "skuid": "${_item.leader_id}",
        "link": "${config.webapplink}/${$des}?id=${_item.leader_id}"
      }`
      return superLink(data)
    },
    getGuideStatus(val) { // 获取子组件的返回
      this.guideShow = false
    },
    // 聚合页规则 访问量收集
    onRuleTrigger () {
      sensors.track('MCINDEX2024_rule_click', {
        MCINDEX_title: 'brand',
        from: '2024指数_最受欢迎的品牌页面规则/奖项说明点击',
        PlatformType: platformType()
      })
    }
  }
}
</script>
